const config = {
  enName2: "",
  enName3: "",
  enName4: "BX",
  cnName: "宝星环球投资",
  cnName2: "宝星",
  www: "",
  images: "",
  openapi: "",
  restful: "https://restful.pubhx.com:3032",
  app: "",
  myid: "",
  goquote: "http://goquote",
  gts2hangqing: "https://gts2hangqing",
  userCenter: "",
  realAccount: "",
  appVersion: {
    ios: "",
    android: "",
    google: "",
  },
  googlePlay: "",
  location: "",
  file: "",
};
if (typeof window !== "undefined") {
  let origin = window.location.origin;
  const protocol = `${origin.split("://")[0]}://`;
  const host = origin.split("://")[1].split(":")[0];
  const domain = host.indexOf(".") < 0 || host.includes("172") ? host : `${host.split(".")[1]}.${host.split(".")[2]}`;
  const port = origin.split("://")[1].split(":")[1] ? `:${origin.split("://")[1].split(":")[1]}` : "";
  if (domain == "localhost" || domain.includes("172")) {
    const local = "172.20.115.141";
    config.www = `${protocol}${local}:6003`;
    config.images = `${protocol}${local}:6004`;
    config.app = `${protocol}${local}:6008`;
    config.myid = `${protocol}${local}:6005`;
    config.openapi = `https://openapi.buwdo.com:6500`;
    config.enName2 = `${"buwdo.com".toUpperCase()}`;
    config.enName3 = `www.${"buwdo.com"}`;
  } else if (domain == "b16cloud.com") {
    config.www = `${protocol}www.${domain}`;
    config.images = `${protocol}images.${domain}`;
    config.app = `${protocol}app.${domain}`;
    config.myid = `${protocol}myid.${domain}`;
    config.openapi = `https://openapi.buwdo.com:6500`;
    config.enName2 = `${"buwdo.com".toUpperCase()}`;
    config.enName3 = `www.${"buwdo.com"}`;
  } else {
    config.www = `${protocol}www.${domain}${port}`;
    config.images = `${protocol}images.${domain}${port}`;
    config.app = `${protocol}app.${domain}${port}`;
    config.myid = `${protocol}myid.${domain}${port}`;
    config.openapi = `https://openapi.${domain}${port}`;
    config.enName2 = `${"buwdo.com".toUpperCase()}`;
    config.enName3 = `www.${"buwdo.com"}`;
  }
}
export default config;
